import styled from 'styled-components';
import { DRAG_HANDLE_OFFSET_PX } from '../../constants';

export const Shell = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: visible;
  background: ${(props) => props.theme.colors.white};
  border-radius: ${(props) => props.theme.borderRadius.base};
  border: 1px solid ${(props) => props.theme.colors.border};
  transition: box-shadow 0.03s ease-out;

  ${(props) =>
    props.$isHovered &&
    props.$isEditMode &&
    `
    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.06);
  `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.sm};
  flex-shrink: 0;
  padding: ${(props) => props.theme.spacing.sm} ${(props) => props.theme.spacing.xxl};
  min-height: 50px;
  position: relative;
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: ${(props) => props.theme.spacing.xs};
`;

export const Title = styled.span`
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-weight: 600;
  font-size: ${(props) => props.theme.fontSize.sm};
  color: ${(props) => props.theme.colors.black};
  letter-spacing: 0.48px;
  text-transform: uppercase;
  line-height: 1;
`;

export const Description = styled.span`
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-weight: 500;
  font-size: ${(props) => props.theme.fontSize.sm};
  color: ${(props) => props.theme.colors.davysGrey};
  line-height: 1.25;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.xs};
  flex-shrink: 0;
`;

export const DragHandleWrapper = styled.div`
  position: absolute;
  left: -${DRAG_HANDLE_OFFSET_PX}px;
  top: 50%;
  transform: translateY(-50%);
  background: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacing.xs};
  border-radius: ${(props) => props.theme.borderRadius.sm};
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  visibility: ${(props) => (props.$visible ? 'visible' : 'hidden')};
  pointer-events: ${(props) => (props.$visible ? 'auto' : 'none')};
  transition: opacity 0.03s ease-out;
  cursor: grab;

  & .widget-drag-handle {
    cursor: grab;
  }
`;

export const BodyTopSlot = styled.div`
  flex-shrink: 0;
  padding: 0 ${(props) => props.theme.spacing.xxl};
`;

export const ContentArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 ${(props) => props.theme.spacing.xxl} ${(props) => props.theme.spacing.xxl};
  cursor: pointer;
`;

export const FooterSlot = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing.md};
  flex-shrink: 0;
  padding: 0 ${(props) => props.theme.spacing.xxl} ${(props) => props.theme.spacing.xxl};
  flex-wrap: wrap;

  ${(props) =>
    props.$disposition === 'vertical' &&
    `
    flex-direction: column;
  `}
`;
